import { AnimatedTextBlock } from "@components/atoms/AnimatedTextBlock"
import { BlockItem } from "@components/atoms/BlockItem"
import { BlockWrapper } from "@components/atoms/BlockWrapper"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"
import { twMerge } from "tailwind-merge"

export const meta: BlockMeta = {
  title: "Terms Text",
}

export default defineBlock("terms/text", (props) => {
  const [title, setTitle] = useInlineEditableValue("title", "Example heading")
  const showTitle = (title && title !== "Example heading") || env.admin

  return (
    <div className="flex w-full gap-8 justify-between flex-col md:flex-row pb-6">
      <div className={twMerge("w-full md:w-[calc(50%-var(--spacing-6)+var(--spacing-2)*2)] md:shrink-0 hidden md:block", showTitle ? "block" : "")}>
        {showTitle && (
          <AnimatedTextBlock textKey="title" textClassName="type-title-l" triggerStart="top bottom-=15%" triggerEnd="bottom top" placeholder="Example heading" />
        )}
      </div>
      <div className="w-full md:w-[calc(50%-var(--spacing-6)+var(--spacing-2)*2)] type-body-m [&_p]:mb-5">
        <InnerBlocks
          template={[
            ["core/paragraph", { placeholder: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at" }],
          ]}
          allowedBlocks={["core/paragraph", "core/list"]}
          orientation="vertical"
        />
      </div>
    </div>
  )
})